import {
  Component, Input, ContentChild, OnInit,
  AfterViewInit, OnDestroy, Output, EventEmitter, HostBinding,
} from '@angular/core';

import * as _ from 'lodash';

import { CollapseComponent } from '../collapse/collapse.component';
import { CollapseHeaderDirective } from '../collapse-header.directive';
import { DownArrowIconDirective } from '../../icon/down-arrow-icon.directive';
import { EditableDetailsIconComponent } from '../../table/table-editable/editable-details-icon/editable-details-icon.component';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'collapse-group, [collapseGroup]',
  styleUrls: ['collapse-group.component.scss'],
  template: '<ng-content></ng-content>',
})
export class CollapseGroupComponent implements OnInit, AfterViewInit, OnDestroy {

  @ContentChild(CollapseComponent, {static: false}) collapseComponent: CollapseComponent;

  @ContentChild(CollapseHeaderDirective, {static: false}) collapseHeader: CollapseHeaderDirective;

  @ContentChild(DownArrowIconDirective, {static: false}) downArrow: DownArrowIconDirective;

  @ContentChild(EditableDetailsIconComponent, {static: false}) editableDetailsIcon: EditableDetailsIconComponent;

  @Input() enabled: boolean = true;

  @Input() name: string; // not required, may be used as identificator

  @Output() open: EventEmitter<any> = new EventEmitter();

  @Output() animationDone: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.collapsed')
  @Input() collapsed: boolean = true;

  private isActive: boolean = true;

  ngOnInit() {
    if (this.collapseHeader) {
      this.collapseHeader.setEnabled(this.enabled);
    }
    if (this.downArrow) {
      this.downArrow.setVisible(this.enabled);
    }
  }

  ngAfterViewInit() {
    if (this.enabled) {
      if (this.collapseHeader) {
        this.collapseHeader.changeCollapse
          .pipe(takeWhile(() => this.isActive))
          .subscribe(() => {
            this.toggle();
            if (this.downArrow) {
              this.downArrow.toggle();
            }
            this.toggleEditableDetailsIcon();
          });
      }

      if (this.collapseComponent) {
        this.collapseComponent.animationDone
          .pipe(takeWhile(() => this.isActive))
          .subscribe(() => {
            this.animationDone.emit(_.get(this.collapseComponent, 'collapse'));
          });
      }
    }
  }

  ngOnDestroy() {
    this.isActive = false;
  }

  public setCollapsed(collapsed: boolean = true) {
    if (this.collapseComponent) {
      this.collapseComponent.setCollapsed(collapsed);
    }
    if (this.collapseHeader) {
      this.collapseHeader.setCollapsed(collapsed);
    }
    this.collapsed = collapsed;
    if (this.downArrow) {
      this.downArrow.setUp(!collapsed);
    }
    this.emitOpenEvent();
  }

  public toggle() {
    if (this.collapseComponent) {
      this.collapseComponent.toggle();
    }
    if (this.collapseHeader) {
      this.collapseHeader.toggle();
    }
    this.collapsed = !this.collapsed;
    this.emitOpenEvent();
  }

  public toggleEditableDetailsIcon() {
    if (this.editableDetailsIcon) {
      this.editableDetailsIcon.toggle();
    }
  }

  // private
  private emitOpenEvent() {
    this.open.emit(!this.collapsed);
  }

}
